import { CampingMapDTO, CampingMapEntity } from "./campingMap.dto";

export function dtoToEntity(dto: CampingMapDTO): CampingMapEntity {
  const raw = dto.unitSelectionMapConfiguration
    ? JSON.parse(dto.unitSelectionMapConfiguration)
    : {};
  return { id: "campingMap", ...raw } as CampingMapEntity;
}

export function entityToDto(entity: CampingMapEntity): CampingMapDTO {
  const { id: _id, ...rest } = entity;
  return { unitSelectionMapConfiguration: JSON.stringify(rest) };
}
